import replaceHash from '../../util/replaceHash';

/**
 * Template: content pagina met tabs
 * Warning: This component is also partly used by the
 * landingspagina template. This template is an remnant
 * from the Acato era.
 */
export class PageTabs {
  /**
     * The page tabs class for the tabs on the `contentpage-tabs` template
     */
  constructor() {
    if ($('.page-tabs').length === 0) {
      return;
    }

    this.$item = $('.page-tabs__item');
    this.$pageTab = $('.page-tabs__tab');
    this.$mobileTrigger = $('.page-tabs__item--mobile');
    this.$hiddenElements = $('.page-tabs__item--hidden');

    this.showMoreTitle = this.$mobileTrigger.text();

    this.init();

    this.$item.on('click', e => this.onNavClicked(e));
    this.$mobileTrigger.on('click', e => this.toggleMobileMenu(e));
  }

  /**
     * Show the initial tab
     * Note: hash is set as param so we can test it
     */
  init(hash = window.location.hash) {
    if (hash.length > 0) {
      this.openTab(hash);
    } else {
      this.$pageTab.eq(0).addClass('page-tabs__tab--active');
      // .eq(0) is the mobile trigger
      this.$item.eq(1).find('a').addClass('page-tabs__item--active');
    }
  }

  /**
     * Gets the hash from the clicked link
     * @param e
     */
  onNavClicked(e) {
    const hash = $(e.currentTarget).find('a').attr('href');

    // if(this.isMobile()) {
    //     this.$hiddenElements.toggle();
    //     this.$mobileTrigger.toggleClass('active');
    // }

    if (!hash || !hash.startsWith('#')) {
      return;
    }

    e.preventDefault();
    this.openTab(hash);
    replaceHash(hash);
  }

  /**
     * Hides the previous tabs and shows the next
     * @param hash
     */
  openTab(hash) {
    $('.page-tabs__tab--active').removeClass('page-tabs__tab--active');
    $('.page-tabs__item--active').removeClass('page-tabs__item--active');
    $(hash).addClass('page-tabs__tab--active');
    $(`a[href="${hash}"]`).addClass('page-tabs__item--active');
  }

  /**
     * Sets the menu title
     * @param e
     */
  toggleMobileMenu(e) {
    e.preventDefault();
    const $this = $(e.currentTarget);
    $this.toggleClass('active');
    this.$hiddenElements.toggle();

    if ($this.hasClass('active')) {
      $this.text('Navigatie verbergen');
    } else {
      $this.text(this.showMoreTitle);
    }
  }

  /**
     * Checks if user has smalls creen
     * @returns {boolean}
     */
  isMobile() {
    return $(window).width() < 767;
  }
}

